import React, { FunctionComponent } from "react";
import { Button } from "react-bootstrap";
import { ButtonVariant } from "react-bootstrap/types";

import { ApplicationLinkProps, makeApplicationLink } from "../utils/applicationUtils";

interface ApplicationLinkButtonProps extends ApplicationLinkProps {
    variant: ButtonVariant;
}

const ApplicationLinkButton: FunctionComponent<ApplicationLinkButtonProps> = props => {
    const handleClick = (): void => {
        window.location.href = makeApplicationLink(props);
    };

    return (
        <Button variant={props.variant} onClick={handleClick}>
            {props.children}
        </Button>
    );
};

export default ApplicationLinkButton;
